// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bcf23","content":"_53676"};